export default class dateHandler {
  constructor(date, format = null) {
    // date = "year, month, day, hours, minutes, seconds, milliseconds"
    // dateString = "October 13, 2014 11:13:00"
    this.date = new Date(date)
  }

  getDate = (format = 'YYYY/MM/DD hh:mm:ss') => {
    return this.format(format)
  }

  getYear = () => {
    return this.date.getFullYear()
  }

  getMonth = (withZero = false) => {
    if (withZero && Number(this.date.getMonth()) < 10) {
      return `0${Number(this.date.getMonth()) + 1}`
    }
    return Number(this.date.getMonth()) + 1
  }

  getDay = (withZero = false) => {
    if (withZero && Number(this.date.getDate()) < 10) {
      return `0${Number(this.date.getDate())}`
    }
    return Number(this.date.getDate())
  }

  get24Hour = (withZero = false) => {
    if (withZero && Number(this.date.getHours()) < 10) {
      return `0${Number(this.date.getHours())}`
    }
    return this.date.getHours()
  }

  get12Hour = (withZero = false) => {
    let hour = this.get24Hour()
    if (Number(hour) === 0) {
      return 12
    } else if (hour < 12) {
      if (withZero && Number(hour) < 10) {
        return `0${Number(hour)}`
      }
      return hour
    }
    else if ( hour === 12) return hour

    if (withZero && Number(hour % 12) < 10) {
      return `0${Number(hour % 12)}`
    }
    return hour % 12
  }

  getAMPM = () => {
    let hour = this.get24Hour()
    if (hour < 12) {
      return 'am'
    }
    return 'pm'
  }

  getMinutes = (withZero = false) => {
    if (withZero && Number(this.date.getMinutes()) < 10) {
      return `0${Number(this.date.getMinutes())}`
    }
    return this.date.getMinutes()
  }

  getSeconds = (withZero = false) => {
    if (withZero && Number(this.date.getSeconds()) < 10) {
      return `0${Number(this.date.getSeconds())}`
    }
    return this.date.getSeconds()
  }

  getMilliseconds = () => {
    return this.date.getMilliseconds()
  }

  getTimeStamps = () => {
    return this.date.getTime()
  }

  getWeekDay = () => {
    return Number(this.date.getDay()) + 1
  }

  getWeekDayFullName = () => {
    const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    return weekdays[this.date.getDay()]
  }

  getWeekDayShortName = () => {
    const weekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    return weekdays[this.date.getDay()]
  }

  getMonthFullName = () => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return months[this.getMonth()-1]
  }

  getMonthShortName = () => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[this.getMonth() - 1]
  }

  format = (string) => {
    // possible String
    // YYYY -> Full Year
    // YY -> Short Year
    // MMM -> Month FullName
    // MM -> Month ShortName
    // 0M -> Month Number with Zero 1 - 12
    // M -> Month Number without Zero 1 - 12
    // DDD -> Day FullName
    // DD -> Day ShortName
    // 0D -> Day ShortName
    // D -> Day ShortName
    // hh -> hour 24 format
    // 0hh -> hour 24 format with zero
    // h -> hour 12 format
    // 0h -> hour 12 format with zero
    // 0mm -> minites with zero
    // mm -> minites
    // 0ss -> seconds with zero
    // ss -> seconds
    // a -> am or pm
    // A -> AM or PM


    if (string.includes("YYYY")) {
      string = string.replace("YYYY", this.getYear());
    } else if (string.includes("YY")) {
      string = string.replace("YY", this.getYear().substr(2, 2));
    }

    if (string.includes("MMM")) {
      string = string.replace("MMM", this.getMonthFullName());
    } else if (string.includes("MM")) {
      string = string.replace("MM", this.getMonthShortName());
    } else if (string.includes("0M")) {
      string = string.replace("0M", this.getMonth(true));
    } else if (string.includes("M")) {
      string = string.replace("M", this.getMonth());
    }


    if (string.includes("DDD")) {
      string = string.replace("DDD", this.getWeekDayFullName());
    } else if (string.includes("DD")) {
      string = string.replace("DD", this.getWeekDayShortName());
    } else if (string.includes("0D")) {
      string = string.replace("0D", this.getDay(true));
    } else if (string.includes("D")) {
      string = string.replace("D", this.getDay());
    }

    if (string.includes("0hh")) {
      string = string.replace("0hh", this.get24Hour(true));
    } else if (string.includes("hh")) {
      string = string.replace("hh", this.get24Hour());
    } else if (string.includes("0h")) {
      string = string.replace("0h", this.get12Hour(true));
    } else if (string.includes("h")) {
      string = string.replace("h", this.get12Hour());
    }


    if (string.includes("0mm")) {
      string = string.replace("0mm", this.getMinutes(true));
    } else if (string.includes("mm")) {
      string = string.replace("mm", this.getMinutes());
    }

    if (string.includes("0ss")) {
      string = string.replace("0ss", this.getSeconds(true));
    } else if (string.includes("ss")) {
      string = string.replace("ss", this.getSeconds());
    }

    if (string.includes("a")) {
      string = string.replace("a", this.getAMPM());
    }

    if (string.includes("A")) {
      string = string.replace("A", this.getAMPM().toUpperCase());
    }

    return string
  }

}




// WEBPACK FOOTER //
// ./src/AtomicUtils/dateHandler.js